"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVoucherText = void 0;
var lang_1 = require("../../../utils/lang");
var store_1 = require("./store");
var getLang = lang_1.getEzbuyLang();
function getVoucherText(voucherState, hasLink) {
    var text = "";
    switch (voucherState) {
        case store_1.VoucherState.ComingSoon:
            text = getLang("COMING SOON");
            break;
        case store_1.VoucherState.canReceive:
            text = getLang("GRAB NOW");
            break;
        case store_1.VoucherState.Received:
            if (hasLink) {
                text = getLang("GO SHOPPING");
            }
            else {
                text = getLang("REDEEMED");
            }
            break;
        case store_1.VoucherState.RanOut:
            return getLang("FULLY REDEEMED");
        default:
            return getLang("EXPIRED");
    }
    return text;
}
exports.getVoucherText = getVoucherText;
